import React from 'react';
import RightArrow from '../../img/right.svg'
import './option-item.less'

const OptionItem = (props = { showDescLabel: false }) => {
    return (
        <div
            className={
                [
                    'merchant-option-item',
                    props.deactivated || props.disable ? 'disable' : null,
                    props.active ? 'active' : null
                ].join(' ')
            }
            onClick={() => {
                if (props.disable || props.deactivated) return;
                if (props.onClick) props.onClick(props.data);
            }}
        >
            <div className="left">
                <div className="title" title={props.title}>
                    <h2>{props.title}</h2>
                    {props.disable && props.showDisableTag && <span className="tag">已冻结</span>}
                    {props.deactivated && props.showDisableTag && <span className="tag">已失效</span>}
                </div>
                <span className="desc" title={props.desc}>
                    {
                        props.showDescLabel && '所属商户: '
                    }
                    {props.desc}
                </span>
            </div>
            <div className="right">
                {
                    !(props.disable || props.deactivated || props.active) && <span>切换该商户 <img
                        src={RightArrow}
                        className="arrow"
                        alt="arrow"
                    /></span>

                }
                {(props.active && "当前商户")}
            </div>
        </div>
    );
};


export default OptionItem;
